import { useContext } from 'preact/hooks';

import { PhoneContext } from './PhoneContext';

export const usePhoneContext = () => {
  const contextValue = useContext(PhoneContext);
  const {
    phoneNumber,
    setPhoneNumber,
    selectedCountry,
    setSelectedCountry,
    onPhoneSubmit,
    setOnPhoneSubmit,
    onPhoneCancel,
    setOnPhoneCancel,
    showPhoneInput,
    setShowPhoneInput,
  } = contextValue;

  if (contextValue === undefined) {
    throw new Error('usePhoneContext must be used within a PhoneProvider');
  }

  return {
    phoneNumber: phoneNumber || '',
    setPhoneNumber: setPhoneNumber || (() => {}),
    selectedCountry,
    setSelectedCountry: setSelectedCountry || (() => {}),
    onPhoneSubmit,
    setOnPhoneSubmit: setOnPhoneSubmit || (() => {}),
    onPhoneCancel,
    setOnPhoneCancel: setOnPhoneCancel || (() => {}),
    showPhoneInput,
    setShowPhoneInput: setShowPhoneInput || (() => {}),
  };
};
